(function () {
  'use strict';
  function computeVariantState({enablePurchase, available, priceCents, formattedPrice}) {
    const hasPrice = Number.isFinite(priceCents) && priceCents > 0;
    const canBuy = enablePurchase === true && available === true && hasPrice;
    return {
      canBuy,
      buttonLabel: !enablePurchase || !hasPrice ? 'Coming soon' : available ? 'Add to bag' : 'Unavailable',
      priceLabel: hasPrice ? formattedPrice : 'Price to be confirmed'
    };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {computeVariantState};
  if (typeof document === 'undefined') return;
  document.querySelectorAll('[data-gallery-src]').forEach(button => button.addEventListener('click', () => {
    const img = document.querySelector('.product-main-image');
    if (!img) return;
    img.removeAttribute('srcset');
    img.src = button.dataset.gallerySrc;
    img.alt = button.dataset.galleryAlt;
    document.querySelectorAll('.thumbnail').forEach(el => el.classList.toggle('active', el === button));
  }));
  document.querySelectorAll('select[name="id"]').forEach(select => {
    function updateVariant() {
      const option = select.selectedOptions[0];
      if (!option) return;
      const scope = select.closest('.product-layout');
      if (!scope) return;
      const button = scope.querySelector('[data-product-submit]');
      const state = computeVariantState({
        enablePurchase: button?.dataset.enablePurchase === 'true',
        available: option.dataset.available === 'true',
        priceCents: Number(option.dataset.priceCents),
        formattedPrice: option.dataset.price
      });
      const price = scope.querySelector('[data-price]');
      if (price) price.textContent = state.priceLabel;
      if (button) {
        button.disabled = !state.canBuy;
        button.textContent = state.buttonLabel;
      }
      const image = scope.querySelector('.product-main-image');
      if (image && option.dataset.kitImage) {
        image.removeAttribute('srcset');
        image.src = option.dataset.kitImage;
        image.alt = option.dataset.kitAlt || '';
        const variantThumbnail = scope.querySelector('[data-variant-thumbnail]');
        if (variantThumbnail) {
          variantThumbnail.dataset.gallerySrc = option.dataset.kitImage;
          variantThumbnail.dataset.galleryAlt = option.dataset.kitAlt || '';
          const thumbnailImage = variantThumbnail.querySelector('img');
          if (thumbnailImage) thumbnailImage.src = option.dataset.kitImage;
          scope.querySelectorAll('.thumbnail').forEach(el => el.classList.toggle('active', el === variantThumbnail));
        }
      }
    }
    select.addEventListener('change', updateVariant);
    updateVariant();
  });
})();
